import { atom } from "jotai";
import { queryRule } from "../../../service/score";
import { atomFamily } from "jotai/utils";
import { isTrue } from "../../../service/service";

export const isProcessAtom = atom<BooleanValue>("0");

export const disabledAtom = atomFamily(
    ({ courseNo, courseSeq }: { courseNo: string; courseSeq: string }) => {
        return atom(async get => {
            const res = await queryRule(courseNo, courseSeq);
            return !isTrue(res.canEdit);
        });
    },
    (arg1, arg2) => {
        return (
            arg1.courseNo === arg2.courseNo && arg1.courseSeq === arg2.courseSeq
        );
    }
);

export const countAtom = atom(0);
